module.exports = __webpack_public_path__ + "static/media/ThumbnailStill07.c3f7e117.png";